export const getPreviewAssetsStepShimmerStyles = () => ({
  stepTitle: {
    maxWidth: '240px',
  },
  stepDescription: {
    maxWidth: '560px',
    margin: '16px 0 36px 0',
  },
  previewStepContent: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '32px',
  },
  previewGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  'previewGroup-xxl': {
    width: '530px',
  },
  'previewGroup-xl': {
    width: '430px',
  },
  adPreviewContainer: {
    flexGrow: '1',
  },
  'adPreviewContainer-l': {
    width: '100%',
  },
  'adPreviewContainer-m': {
    width: '100%',
  },
  'adPreviewContainer-s': {
    width: '100%',
  },
});
